export enum EIcons {
  iconChevron = 'icon-chevron',
  iconChevronLeft = 'icon-chevron-left',
  iconClose = 'icon-close',
  iconPlus = 'icon-plus',
  iconChevronRight = 'icon-chevron-right',
  iconArrowLeftButton = 'icon-arrow-left-button',
  iconArrowRightButton = 'icon-arrow-right-button',
  iconLock = 'icon-lock',
  iconSearch = 'icon-search',
}
